import { registerConnection } from 'apis/Lti/Lti';
import { useAppStore } from 'hooks/useAppStore';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { ErrorResponse } from 'types';
import { fetchServerError } from 'utils';

export const useRegisterConnection = () => {
  const {
    workspaceStore: { currentWorkspaceId },
  } = useAppStore();
  const queryClient = useQueryClient();
  const queryKey = ['workspaces', currentWorkspaceId, 'connections'];

  return useMutation(registerConnection, {
    onSuccess: () => {
      queryClient.invalidateQueries(queryKey);
      toast.success('New connection has been added successfully.');
    },
    onError: (errorResponse: ErrorResponse) => {
      toast(fetchServerError(errorResponse), { type: 'error' });
    },
  });
};
